import { FC } from 'react';

import { LoaderItemStyled, LoaderWrapStyled } from './ButtonLoader.styled';

type ButtonLoaderPropsT = {
  color?: 'white' | 'darkBlue';
  variant?: 'round' | 'brick';
};

const ButtonLoader: FC<ButtonLoaderPropsT> = props => (
  <LoaderWrapStyled>
    <LoaderItemStyled {...props} />
    <LoaderItemStyled delayAnimation {...props} />
    <LoaderItemStyled {...props} />
  </LoaderWrapStyled>
);

export default ButtonLoader;
